import React from 'react';
import { Row, Col, Avatar } from 'antd';
import {DateUtils,Card, useTranslation, Button } from 'soxo-bootstrap-core';
import './info-card.scss';
import SectionHeaderonHeader from './section-header';

const GuestInfo = ({ guest, onCancel }) => {
    const { t } = useTranslation();

    const isCorporate = guest.type === 'PYR' || guest.mode === 'CCUS'; // check if guest is corporate

    return (
        <div className="guest-information">
            <div className="guest-info-header">
                {/* <SectionHeaderonHeader title={isCorporate ? 'Corporate Information' : 'Guest Information'} /> */}
                <Button type="secondary" onClick={onCancel} size="small">
                    {t('Cancel')}
                </Button>
            </div>

            <Card className="guest-info-card">
                <Row gutter={16} align="middle">
                    <Col>
                        <Avatar
                            size={50}
                            shape="square"
                            style={{
                                backgroundColor: '#E6F0FF',
                                color: '#2A5BD7',
                                fontWeight: 600,
                                fontSize: 18,
                            }}
                        >
                            {isCorporate
                                ? guest.description
                                    ? guest.description.charAt(0)
                                    : 'C'
                                : guest.Full_name
                                ? guest.Full_name.charAt(0)
                                : 'U'}
                        </Avatar>
                    </Col>

                    <Col flex="auto">
                        <div className="guest-infos">
                            {isCorporate ? (
                                <>
                                    <h4 className="guest-name">{guest.description}</h4>
                                    <Row gutter={[32, 8]}>
                                        <Col>
                                            <span className="label">Code:</span> {guest.code}
                                        </Col>
                                        <Col>
                                            <span className="label">Phone:</span> {guest.moblie || guest.phone || ''}
                                        </Col>
                                    </Row>
                                </>
                            ) : (
                                <>
                                    <h4 className="guest-name">{guest.Full_name}</h4>
                                    <Row gutter={[32, 8]}>
                                        <Col>
                                            <span className="label">Dob:</span>
                                            {guest.dob ? DateUtils.formatDate(guest.dob) : ''}
                                        </Col>{' '}
                                        <Col>
                                            <span className="label">Email:</span> {guest.email}
                                        </Col>
                                        <Col>
                                            <span className="label">Address:</span> {(guest.address1 || "") + " " + (guest.address2 || "")}
                                        </Col>
                                    </Row>
                                    <Row gutter={[32, 8]}>
                                        <Col>
                                            <span className="label">{guest.gender}</span> | {guest.age_year}
                                        </Col>
                                        <Col>
                                            <span className="label">Contact:</span> {guest.mobile1}
                                        </Col>
                                    </Row>
                                </>
                            )}
                        </div>
                    </Col>
                </Row>
            </Card>
        </div>
    );
};

export default GuestInfo;
